import React from 'react';

export default () => <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M4.32247e-07 6.75L9.23176 6.75L5.15226 10.95L6.17213 12L12 6L6.17213 -5.09488e-07L5.15226 1.05L9.23176 5.25L5.55746e-07 5.25L4.32247e-07 6.75Z"/></svg>;
